import { render, staticRenderFns } from "./allocateQuota.vue?vue&type=template&id=5b1394fe&scoped=true"
import script from "./allocateQuota.vue?vue&type=script&lang=js"
export * from "./allocateQuota.vue?vue&type=script&lang=js"
import style0 from "./allocateQuota.vue?vue&type=style&index=0&id=5b1394fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1394fe",
  null
  
)

export default component.exports